var flyoutMagicTriangle;

flyoutMagicTriangle = require('./flyout_magic_triangle');

module.exports = {
  init: function() {
    var $firstLink, $goodsTab, $menuElem, $nestedLinks, flyoutInstance, flyoutOpts;
    $goodsTab = $('#subnav-goods-tab');
    if (!($menuElem = $goodsTab.find('.ls-gcx-flyout-menu')).length) {
      return;
    }
    flyoutOpts = {
      $menuElem: $menuElem,
      rowSelector: '.ls-gcx-flyout-nested-links',
      delay: 200,
      onActivateRow: function(elem) {
        return $(elem).addClass('ls-gcx-flyout-active');
      },
      onDeactivateRow: function(elem) {
        return $(elem).removeClass('ls-gcx-flyout-active');
      }
    };
    $('.ls-gcx-flyout-category-image').lazyload({
      container: '#goods-tab',
      event: 'mouseover',
      performantScroll: true,
      skip_initial_check: true,
      skip_invisible: false
    });
    flyoutInstance = flyoutMagicTriangle(flyoutOpts);
    if (!flyoutInstance) {
      return;
    }
    $nestedLinks = $menuElem.find('.ls-gcx-flyout-nested-links');
    $nestedLinks.on('tap', function(e) {
      e.stopPropagation();
      return flyoutInstance.activateRow($(e.currentTarget));
    });
    $firstLink = $nestedLinks.first();
    return $goodsTab.bind('tab:active', function() {
      return flyoutInstance.activateRow($firstLink);
    });
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL21vZHVsZXMvZ2lnX2JvZHkvaGVhZGVyL3N1Yl9uYXYvZnJvbnRlbmQvaW5pdF9mbHlvdXQuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL3NraW0vc2xzL21vZHVsZXMvZ2lnX2JvZHkvaGVhZGVyL3N1Yl9uYXYvZnJvbnRlbmQvaW5pdF9mbHlvdXQuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsbUJBQUEsR0FBc0IsT0FBQSxDQUFRLHlCQUFSOztBQUV0QixNQUFNLENBQUMsT0FBUCxHQUNFO0VBQUEsSUFBQSxFQUFNLFNBQUE7QUFDSixRQUFBO0lBQUEsU0FBQSxHQUFZLENBQUEsQ0FBRSxtQkFBRjtJQUNaLElBQUEsQ0FBYyxDQUFDLFNBQUEsR0FBWSxTQUFTLENBQUMsSUFBVixDQUFlLHFCQUFmLENBQWIsQ0FBbUQsQ0FBQyxNQUFsRTtBQUFBLGFBQUE7O0lBRUEsVUFBQSxHQUFhO01BQ1gsV0FBQSxTQURXO01BRVgsV0FBQSxFQUFhLDZCQUZGO01BR1gsS0FBQSxFQUFPLEdBSEk7TUFJWCxhQUFBLEVBQWUsU0FBQyxJQUFEO2VBQ2IsQ0FBQSxDQUFFLElBQUYsQ0FBTyxDQUFDLFFBQVIsQ0FBaUIsc0JBQWpCO01BRGEsQ0FKSjtNQU1YLGVBQUEsRUFBaUIsU0FBQyxJQUFEO2VBQ2YsQ0FBQSxDQUFFLElBQUYsQ0FBTyxDQUFDLFdBQVIsQ0FBb0Isc0JBQXBCO01BRGUsQ0FOTjs7SUFXYixDQUFBLENBQUUsK0JBQUYsQ0FBa0MsQ0FBQyxRQUFuQyxDQUNFO01BQUEsU0FBQSxFQUFXLFlBQVg7TUFDQSxLQUFBLEVBQU8sV0FEUDtNQUVBLGdCQUFBLEVBQWtCLElBRmxCO01BR0Esa0JBQUEsRUFBb0IsSUFIcEI7TUFJQSxjQUFBLEVBQWdCLEtBSmhCO0tBREY7SUFPQSxjQUFBLEdBQWlCLG1CQUFBLENBQW9CLFVBQXBCO0lBRWpCLElBQUEsQ0FBYyxjQUFkO0FBQUEsYUFBQTs7SUFFQSxZQUFBLEdBQWUsU0FBUyxDQUFDLElBQVYsQ0FBZSw2QkFBZjtJQUNmLFlBQVksQ0FBQyxFQUFiLENBQWdCLEtBQWhCLEVBQXVCLFNBQUMsQ0FBRDtNQUNyQixDQUFDLENBQUMsZUFBRixDQUFBO2FBQ0EsY0FBYyxDQUFDLFdBQWYsQ0FBMkIsQ0FBQSxDQUFFLENBQUMsQ0FBQyxhQUFKLENBQTNCO0lBRnFCLENBQXZCO0lBSUEsVUFBQSxHQUFhLFlBQVksQ0FBQyxLQUFiLENBQUE7V0FFYixTQUFTLENBQUMsSUFBVixDQUFlLFlBQWYsRUFBNkIsU0FBQTthQUMzQixjQUFjLENBQUMsV0FBZixDQUEyQixVQUEzQjtJQUQyQixDQUE3QjtFQWpDSSxDQUFOIn0=
